module.exports = __webpack_public_path__ + "static/media/musk-ox-1900-ii.a8d290a2.jpg";